module.exports = __webpack_public_path__ + "static/media/ChangEKitchenINTA0012_design_clean_v003.fa41b4ef.png";